var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoAnalyseBleu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49.84,
    height: 49.378,
    viewBox: "0 0 49.84 49.378",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 49.84,
    height: 49.378,
    fill: "#02599d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_169",
    "data-name": "Groupe 169",
    transform: "translate(0 0)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_80",
    "data-name": "Groupe 80",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_121",
    "data-name": "Trac\\xE9 121",
    d: "M10.005,48.4a9.986,9.986,0,0,1-7.98-16L21.635,6.384l.921.694L2.946,33.1a8.832,8.832,0,0,0,14.04,10.718l20.3-26.262.912.7L17.9,44.519a10.011,10.011,0,0,1-7.048,3.843c-.283.023-.564.036-.846.036",
    transform: "translate(0 0.981)",
    fill: "#02599d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_122",
    "data-name": "Trac\\xE9 122",
    d: "M36.254,19.073a10.212,10.212,0,0,1-2.248-.279,23.863,23.863,0,0,1-7.977-3.783C20.25,10.967,17.1,5.834,18.853,3.325c.889-1.274,2.831-1.645,5.46-1.046a23.874,23.874,0,0,1,7.978,3.781,23.866,23.866,0,0,1,6.287,6.2c1.465,2.264,1.78,4.215.889,5.488a3.7,3.7,0,0,1-3.213,1.328M22.054,3.151a2.636,2.636,0,0,0-2.256.835c-1.167,1.669,1.376,6.219,6.894,10.079a22.646,22.646,0,0,0,7.571,3.6c2.11.481,3.663.269,4.259-.583s.263-2.383-.912-4.2a22.641,22.641,0,0,0-5.98-5.876,22.645,22.645,0,0,0-7.572-3.6,9.111,9.111,0,0,0-2-.253",
    transform: "translate(2.821 0.307)",
    fill: "#02599d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_123",
    "data-name": "Trac\\xE9 123",
    d: "M38.254,17.073a10.212,10.212,0,0,1-2.248-.279,23.863,23.863,0,0,1-7.977-3.783C22.25,8.967,19.1,3.834,20.853,1.325,21.743.052,23.683-.32,26.312.279a23.874,23.874,0,0,1,7.978,3.781,23.866,23.866,0,0,1,6.287,6.2c1.465,2.264,1.78,4.215.889,5.488a3.7,3.7,0,0,1-3.213,1.328M24.054,1.151a2.636,2.636,0,0,0-2.256.835c-1.167,1.669,1.376,6.219,6.894,10.079a22.646,22.646,0,0,0,7.571,3.6c2.111.481,3.663.269,4.259-.583s.263-2.383-.912-4.2a22.641,22.641,0,0,0-5.98-5.876,22.645,22.645,0,0,0-7.572-3.6,9.111,9.111,0,0,0-2-.253",
    transform: "translate(3.128 0)",
    fill: "#02599d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_124",
    "data-name": "Trac\\xE9 124",
    d: "M19.31,4.35a.577.577,0,0,1-.41-.983L21.242,1a.577.577,0,0,1,.82.811L19.719,4.179a.576.576,0,0,1-.41.171",
    transform: "translate(2.877 0.127)",
    fill: "#02599d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_125",
    "data-name": "Trac\\xE9 125",
    d: "M35.81,16.829a.577.577,0,0,1-.41-.983l2.342-2.368a.577.577,0,1,1,.82.811l-2.343,2.369a.576.576,0,0,1-.41.171",
    transform: "translate(5.411 2.044)",
    fill: "#02599d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_126",
    "data-name": "Trac\\xE9 126",
    d: "M39.579,19.234l-3.854,6.359a4.413,4.413,0,0,0-.408.884l-.264.793a4.373,4.373,0,0,0,.325,3.5l.3.531a4.369,4.369,0,0,0,5.355,1.969l.389-.145a4.372,4.372,0,0,0,2.233-1.877l.238-.4a4.37,4.37,0,0,0,.354-3.671l-.384-1.09a4.343,4.343,0,0,0-.449-.915Z",
    transform: "translate(5.349 2.954)",
    fill: "#02599d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_127",
    "data-name": "Trac\\xE9 127",
    d: "M8.332,26.709,4.208,32.083a6.4,6.4,0,0,0,10.019,7.948L30.113,20.658S12.446,29.371,8.332,26.709",
    transform: "translate(0.443 3.173)",
    fill: "#02599d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoAnalyseBleu);
export default __webpack_public_path__ + "static/media/picto_analyse_bleu.016af6ab6c0a8b61f584db3457058d97.svg";
export { ForwardRef as ReactComponent };